import React from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import sdirlogo from "../../sdirlogo.svg";

const Footer: React.FC = () => {
  const intl = useIntl();
  return (
    <CustomFooter>
      <Container className="container">
        <CustomImg
          className="container"
          src={sdirlogo}
          alt={intl.formatMessage({ id: "logo.alt.text" })}
        />
        <ContactInfoContainer>
          <ContactInfoText>
            {intl.formatMessage({ id: "contact.info" })}
          </ContactInfoText>
          <div>
            <span>{intl.formatMessage({ id: "hotline" })}</span>
            <span>{intl.formatMessage({ id: "hotline.number" })}</span>
          </div>
          <div>
            <span>{intl.formatMessage({ id: "nis.nor" })}</span>
            <span>{intl.formatMessage({ id: "nis.nor.number" })}</span>
          </div>
          <div>
            <span>{intl.formatMessage({ id: "fax" })}</span>
            <span>{intl.formatMessage({ id: "fax.number" })}</span>
          </div>
          <div>
            <span>{intl.formatMessage({ id: "hotline.sr" })}</span>
            <span>{intl.formatMessage({ id: "hotline.sr.number" })}</span>
          </div>
        </ContactInfoContainer>
      </Container>
    </CustomFooter>
  );
};

const Container = styled.div`
  margin: auto;
  padding: 40px 15px 70px 15px;

  @media only screen and (max-width: 730px) {
    max-width: 690px;
  }
  @media only screen and (max-width: 550px) {
    max-width: 510px;
  }
`;

const ContactInfoText = styled.span`
  font-weight: bold;
`;

const CustomImg = styled.img`
  color: ${({ theme }) => theme.colors.background.secondary};
  display: block;
  margin: auto;
  max-width: 1140px;
  @media only screen and (max-width: 1200px) {
    max-width: 930px;
  }
  @media only screen and (max-width: 1000px) {
    max-width: 720px;
  }
  @media only screen and (max-width: 726px) {
    max-width: 540px;
  }
`;

const CustomFooter = styled.footer`
  background-color: ${({ theme }) => theme.colors.primary};
  margin-top: 5em;
  width: 100%;
  @media only screen and (min-width: 595px) {
    max-height: 590px;
  }
  @media only screen and (max-width: 560px) {
    max-height: 522.267px;
  }
  @media only screen and (max-width: 490px) {
    max-height: 483.75px;
  }
  @media only screen and (max-width: 435px) {
    max-height: 424.867px;
  }
`;

const ContactInfoContainer = styled.div`
  text-align: left;
  color: ${({ theme }) => theme.colors.background.secondary};
  :first-child {
    font-weight: bold;
  }
  margin: auto;
  @media only screen and (min-width: 1200px) {
    max-width: 1140px;
  }
  @media only screen and (max-width: 1150px) {
    max-width: 960px;
  }
  @media only screen and (max-width: 968px) {
    max-width: 720px;
  }
  @media only screen and (max-width: 726px) {
    max-width: 540px;
  }
`;

export default Footer;
